import { Check } from "lucide-react";

const STEPS = [
  { id: "coverage", label: "Coverage", num: 1 },
  { id: "blocks", label: "Build Blocks", num: 2 },
  { id: "export", label: "Export", num: 3 },
];

export function WorkflowProgress({ currentStep, completedSteps, onStepClick }) {
  const currentIdx = STEPS.findIndex((s) => s.id === currentStep);

  return (
    <div className="flex items-center gap-1 w-full" data-testid="workflow-progress">
      {STEPS.map((step, idx) => {
        const isActive = step.id === currentStep;
        const isCompleted = completedSteps.includes(step.id);
        const isClickable = isCompleted || idx <= currentIdx;

        return (
          <div key={step.id} className="flex items-center flex-1">
            <button
              onClick={() => isClickable && onStepClick(step.id)}
              disabled={!isClickable}
              data-testid={`workflow-step-${step.id}`}
              className={`flex items-center gap-2 px-3 py-2 text-xs font-medium transition-colors duration-150 w-full ${
                isActive
                  ? "bg-[var(--pf-accent)] text-white"
                  : isCompleted
                    ? "bg-[var(--pf-accent-subtle)] text-[var(--pf-accent)] cursor-pointer hover:bg-[var(--pf-accent)] hover:text-white"
                    : "bg-[var(--pf-surface)] text-[var(--pf-text-muted)]"
              } ${isClickable && !isActive ? "cursor-pointer" : !isClickable ? "cursor-not-allowed" : ""}`}
            >
              <span className={`w-5 h-5 flex items-center justify-center text-[10px] font-bold shrink-0 ${
                isCompleted && !isActive
                  ? "bg-[var(--pf-accent)] text-white"
                  : isActive
                    ? "bg-white/20 text-white"
                    : "bg-[var(--pf-border)] text-[var(--pf-text-muted)]"
              }`}>
                {isCompleted && !isActive ? <Check className="w-3 h-3" /> : step.num}
              </span>
              <span className="truncate">{step.label}</span>
            </button>
            {idx < STEPS.length - 1 && (
              <div className={`w-4 h-px shrink-0 ${idx < currentIdx ? "bg-[var(--pf-accent)]" : "bg-[var(--pf-border)]"}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}
